module.exports = __webpack_public_path__ + "static/media/image_case_beauty.47e5ceb3.png";